import { useState, forwardRef, useImperativeHandle, useContext, useEffect } from 'react';
import { Radio, Checkbox, message } from 'antd';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import API from '@api/api.js';
import eventBus from '@utils/eventBus';
import { AppContext } from '@utils/AppContext';

const ChangeShareMode = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setOpen
    }));
    const { globalOrgInfo } = useContext(AppContext);
    const [open, setOpen] = useState(false)
    const [mode, setMode] = useState(0)
    const [avg, setAvg] = useState(0)

    useEffect(() => {
        setMode(globalOrgInfo?.current?.powerAllocateMode ? 1 : 0)
    }, [globalOrgInfo?.current?.powerAllocateMode])

    const onChange = e => {
        if (e.target.checked) {
            setMode(1)
        }
        setAvg(e.target.checked ? 1 : 0)
    }

    const postChangeAllocateMode = () => {
        if (!localStorage.getItem('token')) return
        if (mode === globalOrgInfo?.current?.powerAllocateMode) {
            message.warning('当前已属于该模式！')
            return
        }
        API.postChangeAllocateMode({
            mode,
            avg,
        }).then((res) => {
            if (res.code == 0) {
                setOpen(false)
                if(mode === 1 ) {
                    message.success('切换成功，请切换下方额度列表查看或分配虹豆！')
                }
                eventBus.emit('updateUserInfo')
                eventBus.emit('getUserOrgInfo')
                eventBus.emit('updatePower')
                eventBus.emit('updateActivityInfo')
            } else {
                message.error(res.message)
            }
        })
    }

    return (
        <PSAIModal
            title='切换虹豆共享模式'
            maxWidth={400}
            okText={'确定'}
            open={open}
            maskClosable={false}
            okButtonProps={{ disabled: false, loading: false }}
            onCancel={() => setOpen(false)}
            onOk={() => postChangeAllocateMode()}
        >
            <div className={styles.modalContent}>
                <div className={styles.modalWarp} style={{ marginBottom: '24px' }}>
                    <Radio
                        checked={mode === 0}
                        onChange={(e) => {
                            setMode(0)
                            setAvg(0)
                        }}
                    >
                        自由共享
                    </Radio>
                    <p>企业成员自由使用套餐内虹豆点数</p>
                </div>
                <div className={styles.modalWarp}>
                    <Radio
                        checked={mode === 1}
                        onChange={(e) => setMode(1)}
                    >
                        管理员分配
                    </Radio>
                    <p>管理员手动为每位成员分配可用的虹豆点数</p>
                    {/* <p><Checkbox checked={avg === 1} onChange={onChange}>一键均分（可用虹豆数/席位数）</Checkbox></p> */}
                </div>
            </div>
        </PSAIModal>
    );
});

export default ChangeShareMode;